import React from "react";
import IconOptions from "../Icons/IconOptions";

const ButtonOptions = function (props) {
  const onClickHandler = function () {
    props.setIsHamburgerOpen(!props.isOpen);
  };

  return (
    <button
      className={props.className}
      aria-label="menu"
      onClick={onClickHandler}
    >
      <IconOptions strokeWidth={0.5} />
    </button>
  );
};

export default ButtonOptions;
